import type { HelpFile } from '../../types/help'
import { FormLayoutListPageTestIds } from '../../../testids/FormLayoutListPageTestIds'

export const formLayoutListPageHelp: HelpFile = {
  docPage: '/docs/schema/form-layouts',
  texts: {
    [FormLayoutListPageTestIds.formLayoutListPage]: 'Browse all form layouts. A layout defines which attributes appear and in what order on a given screen.',
    [FormLayoutListPageTestIds.colKey]: 'Stable identifier of the form layout, used by code to look it up.',
    [FormLayoutListPageTestIds.colUseCase]: 'The screen or workflow this layout is used for, e.g. party create or identity edit.',
    [FormLayoutListPageTestIds.colFormFields]: null,
    [FormLayoutListPageTestIds.colStatus]: 'Whether this layout is active, inactive, or the default for its use case.',
    [FormLayoutListPageTestIds.badgeStatusActive]: 'Layout is active and may be used by callers that select it explicitly.',
    [FormLayoutListPageTestIds.badgeStatusDefault]: 'Layout is the default for its use case and is used when no other is selected.',
    [FormLayoutListPageTestIds.badgeStatusInactive]: 'Layout is inactive and will not be rendered.',
  },
}
